import { render, staticRenderFns } from "./EventInWaitingList.vue?vue&type=template&id=2e40169b&scoped=true&"
import script from "./EventInWaitingList.vue?vue&type=script&lang=js&"
export * from "./EventInWaitingList.vue?vue&type=script&lang=js&"
import style0 from "./EventInWaitingList.vue?vue&type=style&index=0&id=2e40169b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e40169b",
  null
  
)

export default component.exports